import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppService } from 'src/app/services/app/app.service';
import { CommonService } from 'src/app/services/common/common.service';
import { CompanyService } from 'src/app/services/company/company.service';
import { CourseService } from 'src/app/services/course/course.service';
import { DocumentService } from 'src/app/services/document/document.service';
import { ForumService } from 'src/app/services/forum/forum.service';
import { PackageService } from 'src/app/services/package/package.service';
import { StaffSurveyService } from 'src/app/services/staff-survey/staff-survey.service';
import { UserManagementService } from 'src/app/services/user_management/user-management.service';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public dialogData: any, private spinner: NgxSpinnerService, private appService: AppService,
    public dialogRef: MatDialogRef<AlertComponent>, private courseService: CourseService, private forumService: ForumService,
    public userManagementService: UserManagementService, private companyService: CompanyService, private staffSurveyService: StaffSurveyService,
    private packageService: PackageService, private docService: DocumentService, private commonService: CommonService
  ) { }
  ngOnInit(): void {
  }
  onCancel() { 
    if(this.dialogData.api_type=='error'){
    this.dialogRef.close({'data':"close"})
    }
    else{
      this.dialogRef.close()
    }
  }
}
